import { useContext, useMemo } from "react";

import { DataContext } from "contexts/Data";
import { findVariant } from "helpers/variant";

import type { Variant } from "types/app";

/**
 * Only use this hook under DataContext
 */
export default function useVariant(): Variant | undefined {
  const { variants, cachedState } = useContext(DataContext);

  return useMemo(() => {
    if (!variants || !cachedState.variantId) return;

    return findVariant(variants, cachedState.variantId);
  }, [variants, cachedState.variantId]);
}
